import { render } from "./bundleCard.vue?vue&type=template&id=edef5520&scoped=true"
import script from "./bundleCard.vue?vue&type=script&lang=js"
export * from "./bundleCard.vue?vue&type=script&lang=js"

import "./bundleCard.vue?vue&type=style&index=0&id=edef5520&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edef5520"]])

export default __exports__